import { Avatar, Box, Chip, IconButton, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { EditIcon, TomTable, useTomTable } from '@tom-ui/ui'
import { ImoClassStackingRuleDto } from '@yard/app/api/dg-config-api'
import { Permission } from '@yard/app/models/permission.enum'
import { useYardStores } from '@yard/AppProvider'
import { MRT_ColumnDef } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'

const DGStackingRulesTable = observer(() => {
  const { t } = useTranslate()
  const { dgStackingRulesTableUIStore, authStore } = useYardStores()

  const canWrite = authStore.hasPermission(Permission.WriteDangerousGoodsSettings)

  useEffect(() => {
    dgStackingRulesTableUIStore.loadAllDGStackingRules()
  }, [dgStackingRulesTableUIStore])

  const columns = useMemo<MRT_ColumnDef<ImoClassStackingRuleDto>[]>(
    () => [
      {
        accessorKey: 'imoClass',
        header: t('imoClass', 'IMO Class'),
        Cell: ({ row }) => <Chip label={row.original.imoClass} />,
      },
      {
        accessorKey: 'maxTiers',
        header: t('maxTiers', 'Max Tiers'),
        Cell: ({ row }) =>
          row.original.maxTiers > 0 ? <Avatar>{row.original.maxTiers}</Avatar> : null,
      },
      {
        accessorKey: 'isStackingOnTopAllowed',
        header: t('isStackingOnTopAllowed', 'Is stacking on top allowed?'),
        Cell: ({ row }) => (
          <Chip
            label={row.original.isStackingOnTopAllowed ? t('yes', 'Yes') : t('no', 'No')}
            color={row.original.isStackingOnTopAllowed ? 'secondary' : 'error'}
          />
        ),
      },
    ],
    [t],
  )

  const table = useTomTable<ImoClassStackingRuleDto>({
    columns,
    data: dgStackingRulesTableUIStore.dgStackingRules,
    enableSorting: false,
    autoResetPageIndex: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableColumnActions: false,
    enableTopToolbar: false,
    enableRowActions: canWrite,
    enableExpanding: false,
    enableRowSelection: false,
    renderRowActions: ({ row }) =>
      canWrite ? (
        <Box>
          <Tooltip title={t('edit', 'Edit')}>
            <IconButton
              aria-label='edit'
              onClick={() => dgStackingRulesTableUIStore.openEditDialog(row.original.id)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ) : null,
    positionActionsColumn: 'last',
  })

  return <TomTable table={table} />
})

export default DGStackingRulesTable
